<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { AppToast } from '@/design-system'
import { useSettingsStore } from '@/features/settings/stores/settings.store'

// Единая инициализация темы (data-theme + подписка на системную тему для AUTO).
// Анти-FOUC-скрипт в index.html уже выставил начальный data-theme до маунта.
const settingsStore = useSettingsStore()
onMounted(() => {
  settingsStore.initializeSettings()
})
</script>

<template>
  <div class="app">
    <RouterView />
    <AppToast />
  </div>
</template>

<style>
/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-family-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  /* DEV-2234: горизонтального скрытия здесь нет намеренно. `overflow-x: hidden`
     не чинил переполнение, а прятал его: всё, что вылезало за 390px, просто
     становилось недостижимым и не видно при разработке. Если страница поехала
     вбок — это дефект страницы, чинить её, а не глушить тут. */
}

.app {
  width: 100%;
  min-height: 100vh;
  background-color: var(--color-background, #ffffff);
  margin: 0;
  padding: 0;
}
</style>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
